import styled from 'styled-components'

import { Link as DefaultLink } from '@subaio/components'

import { helpers } from 'styles'

export const Link = styled(DefaultLink)`
	display: block;
	width: fit-content;
	color: ${helpers.color.textMuted};
	border-radius: 4px;
	padding: 4px 8px;
	margin: -1px 0;

	&:hover,
	&:active,
	&:focus {
		text-decoration: none;
		color: ${helpers.color.text};
		background-color: ${helpers.color.linkBackgroundHover};
	}

	&.active {
		text-decoration: none;
		color: ${helpers.color.link};
		background-color: ${helpers.color.linkBackgroundActive};
	}
`
